import { gql } from '@apollo/client';

export const LinkFragment = gql`
  fragment LinkFragment on _Linkable {
    __typename
    _linkType
    ... on _Document {
      _meta {
        id
        uid
        type
        lang
      }
    }
    ... on _ImageLink {
      name
      url
      size
      height
      width
    }
    ... on _FileLink {
      name
      url
      size
    }
    ... on _ExternalLink {
      url
    }
    ... on Page {
      page_title
      abstract
      abstract_image
      _meta {
        id
        uid
        tags
        lang
      }
    }
  }
`;
